import { Box, theme } from '@factorialco/deprecated-design-system'

import { ProductDemoCard } from './ProductDemoCard'
import { WhatsIncluded } from './WhatsIncluded'

interface OverviewRightColumnProps {
  navatticImageUrl: string | null
  upsellModalBenefits: string[]
  onLearnMore: () => void
  onProductDemo: () => void
}

export const OverviewRightColumn = ({
  navatticImageUrl,
  upsellModalBenefits,
  onLearnMore,
  onProductDemo,
}: OverviewRightColumnProps) => (
  <Box alignItems="flexStart" style={{ flex: '1 1 0%', minWidth: '0', maxWidth: '320px' }}>
    {navatticImageUrl ? (
      <>
        <ProductDemoCard navatticImageUrl={navatticImageUrl} onProductDemo={onProductDemo} />
        <Box
          style={{
            width: '100%',
            borderBottom: `1px dotted ${theme.colors.grey400 ?? theme.colors.grey300}`,
            marginTop: '16px',
            opacity: '0.5',
          }}
        />
      </>
    ) : null}
    <WhatsIncluded benefits={upsellModalBenefits} />
  </Box>
)
